/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { useSelector } from 'react-redux';
// material
import { CopySnippetField, InlineMessage } from '@insticator/insticator-ui'; // iui-material
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/code/code_styles';



/* ========== ~~~~~~~~~~ COMMENTING CODE ~~~~~~~~~~ ========== */
const Code = (props) => {
    const commentingUnitCode = useSelector(({ commentingState }) => commentingState.codeStatus.commentingUnitCode );
    const isPageIDEnabled = useSelector(({commentingState}) => commentingState.configStatus.general.isPageIDEnabled);
    return(
        <div className={`code ${props.classes.code}`}>
            <CopySnippetField
              title={'Header Code'}
              description={<div>Place the following code right after the <strong>{`<head>`}</strong> tag in your HTML source code.</div>}
              codeSnippet={!commentingUnitCode ? '' : commentingUnitCode.headerCode}
            />
            <div className={`codemessage`}>
                <InlineMessage key={'meow'}
                               display={true}
                               name={'headercode'}
                               variant={'neutral'}
                               icon={'exclamation-triangle'}
                               title={null}
                               message={<span><strong>Insticator Header Code</strong> is the same for all ‘hard-coded’ insticator units – <strong>only add it to your site once.</strong></span>}
                               close={false}
                               handleClose={null} />
            </div>
            <CopySnippetField
              title={'Commenting Unit Code'}
              description={
                <div>Place the Commenting Unit code inside of the <strong>{`<body>`}</strong> tag in your HTML source code where you want the Commenting Unit to appear in your site.
                </div>
              }
              codeSnippet={!commentingUnitCode ? '' : commentingUnitCode.bodyCode}
            />
            {
              isPageIDEnabled ? 
              <div className={`codemessage`}>
                <InlineMessage key={'meow'}
                               display={true}
                               name={'headercode'}
                               variant={'neutral'}
                               icon={'exclamation-triangle'}
                               title={null}
                               message={<span>Make sure you replace <strong>{`{extPageId}`}</strong> with the proper External Page ID value for the specific page.</span>}
                               close={false}
                               handleClose={null} />
              </div> : null
            }
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Code);
